<dx-text-box
    [(value)]="value"
    [maxLength]="props.maxLength"
    [readOnly]="props.readOnly"
    [disabled]="props.disabled"
    [valueChangeEvent]="props.valueChangeEvent"
    stylingMode="underlined"
    (onValueChanged)="handleValueChange($event)">
</dx-text-box>
